export enum CacheNames {
  ACCOUNTS = 'accounts',
  BILLS = 'bills',
  CERTIFICATES = 'certificates',
  VOUCHERS = 'vouchers',
  CYCLES = 'cycles',
  CONCEPTS = 'concepts',
  CONTENT_ITEMS = 'content-items',
  EXCLUDED_DATES = 'excluded-dates',
  EXCHANGE_DATES = 'exchange-dates',
  EXTERNAL_COMPANIES = 'external-companies',
  MAILS = 'mails',
  PARTICIPANTS = 'participants',
  IMAGES = 'images',
  PAGES = 'pages',
}
